export default __webpack_public_path__ + "static/media/illustration-risk_convertibleNote.9e8dee09.png";